import { createThemeCompiler } from '../../../utils';

export const modalThemeCompiler = createThemeCompiler(() => ({
    modal: {
        colors: {
            backgroundColor: '#000000B3'
        }
    }
}));
